import { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { RecommendationTypeActionId } from "../../../utils/constants";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { fill_action } from "../../../actions/fillCombo_action"
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import { getManualForms_action } from "../../../actions/exhibitor_module_actions/manual_Forms_actions/manual_forms_action";
import {
  getExhibitorDashboard_action,
  getDrawerDetails_action,
  insertExhibitorBarcode_action,
} from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import {
  DOC_BASE_URL,
  downloadReport,
  fetchAuthReport,
  NA,
  signatureDocName,
  toastError, bonafideDocName,
  toastSuccess, paymentMasterListActionId,
  BASE_URL
} from "../../../utils/constants";
import { taxInvoiceList_action, invoiceMail_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";
import { getPaymentOrderDetails_action, insertHotelEnquiryDownload_action } from '../../../actions/registration_action'
import { descriptionPreview_action, bulkDescriptionPreview_action } from "../../../actions/description_action"
import { Link } from "react-router-dom";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import KICC_Doc from "../../../files/KICC_DOCUMENTS.pdf";
import exit_pass from "../../../files/EXIT_PASS.docx";
import e_directory from "../../../files/E_DIRECTORY_2023.pdf";
import visitor_database from "../../../files/Visitor_Database.pdf";
import post_event from "../../../files/ITME-AFRICA-2023-Post-Event-Report.pdf";
import moment from "moment";
import { getManageAreaList_action, addManageAreaStall_action, updateManageArea_action } from "../../../actions/admin_module_action/master_action/exhibition_master_action/manage_area_master_action";
import { getExhibitorCircularList_action, getVisitorCircularList_action } from "../../../actions/exhibitor_module_actions/exhibitor_circular_actions/exhibitor_circular_action";
import {
  getExhibitorExitPassDetails_action,
  submitExhibitorExitPass_action, updateExhibitorExitPass_action,
  deleteExitPass_action,
  getAccountExitPassDetail_action,
} from "../../../actions/exhibitor_module_actions/exhibitor_exit_pass_action/exhibitor_exit_pass_action";
import { getLedgerList_action, sendLedger_action, sendOutstanding_action, getLedgerPdf_action } from "../../../actions/admin_module_action/ledger_action/ledger_action";

class Exhibitor_dashboard extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    //States
    this.state = {
      isLoading: false,
      showDamageReportModal: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      isOpenConfirmationModal: false,
      exhibitorDashboardList: [],
      isDrawerData: false,
      isNoDuesData: false,
      isDownloadExhibitorSignature: false,
      isLETTERFROMVENUEKICC: false,
      isDownloadExitPass: false,
      isDownloadEDirectory: false,
      isDownloadVisitorDatabase: false,
      isDownloadPostEventReport: false,
      isParticipationCertificate: false,
      isNoDuescertificate: false,
      isDownloadBonafideCertificate: false,
      stall: '',

      List: [],
      AllManualFormList: [],
      OverDueFormCount: '',
      OverDueFormCountList: '',
      MFDeadlineDays: '',

      installment1stDate: '',
      installment2ndDate: '',
      is2ndPicreated: false,

      circularList: [],
      showExitPass: false,

      formStatus: '',
      deadline: '',
      downloadAll: false,
      txid: '',
      isFull: false,
      makePay: false,
      toOpenManualForm: false,
      ExitPassDueDate: '',
      ndcissueDate: '',
      stallpossdate: '',
      exitdateExh: '',
      exitdatecontractor: '',
      IsHotelBookingFull: false,
      PendingExhManualFormCount: 0,
      PendingExhManualFormList: [],
      ExitPassDamageList: [],

      isPowerDetailsFilled: false,
      isPowerFormFilled: false,
      isWaterDetailsFilled: false,
      isWaterFormFilled: false,
      isAirDetailsFilled: false,
      isAirFormFilled: false,
      isEdirectoryDetailsFilled: false,
      isEdirectoryFormFilled: false,
      ManualFormAlert: false,
      visitorPromocodeUrl: '',
    };
    this.getExhibitorDashboard = this.getExhibitorDashboard.bind(this);
    this.getDrawerDetails = this.getDrawerDetails.bind(this);
    this.onCircularsClick = this.onCircularsClick.bind(this);
    this.onDownloadSignature = this.onDownloadSignature.bind(this);
    this.onDownloadRegForm = this.onDownloadRegForm.bind(this);
    this.paymentDueNavigate = this.paymentDueNavigate.bind(this);
    this.downloadFileHotelEnquiry = this.downloadFileHotelEnquiry.bind(this);
    this.onDocDownload = this.onDocDownload.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.getFillList = this.getFillList.bind(this);

  }

  componentDidMount() {
    this.getExhibitorDashboard();
    this.getManualFormsList()
    this.getManageAreaList()
    this.getDrawerDetails();
    this.getCircularList()
    this.getExhibitorExitPassDetails()
    this.getTaxInvoiceList()
    this.getLedgerList()
    this.getFillList(RecommendationTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then((res) => {
      res.length > 0 && res.map(item => {
        console.log(item.TypeName, JSON.parse(sessionStorage.getItem('loginDataSS')).AccountName)
        if (item.TypeName == JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName) {
          console.log(' item.TypeID', item.TypeID)
          sessionStorage.setItem('typeID', item.TypeID)
          // this.getDeleagateDashboard()
          // this.getCoordinatorDelegate()
        }
      })
    })
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state
    return new Promise((resolve, reject) => {

      this.setState({ isLoading: true })
      this.props
        .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
        .then((data) => {
          if (data.error != 1) {
            // country list
            if (actionID === RecommendationTypeActionId) {
              console.log("exhibitionStatusActionId", data.data)
              this.setState({
                typeList: data.data
              })
              resolve(data.data)
            }
            if (actionID === paymentMasterListActionId) {

              data.data.map(item => {
                if (item.PaymentModuleID == 1) {
                  if (item.IsPaymentEnable) {
                    if (JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91) {
                      if (item.isDomestic) {
                        this.setState({ makePay: true })
                      }
                    } else if (item.isInternational) {
                      this.setState({ makePay: true })
                    }
                  }
                }
              })
              this.setState({ isLoading: false })
              // this.setState({
              //   countryList: data.data,
              //   tempCountryList: data.data,
              //   billTempCountryList: data.data,
              //   isLoading: false,
              // })
              resolve()
            }
          }
        })
    })
  }
  // Get Exhibition Timeline
  getExhibitorDashboard() {
    this.setState({ isLoading: true });
    this.props
      .getExhibitorDashboard_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            PendingExhManualFormCount: data.data[0][0].PendingExhManualForm,
            PendingExhManualFormList: data.data[2],
            ExitPassDamageList: data.data[3],
          })
          console.log("Get getExhibitorDashboard", data.data);
          sessionStorage.setItem(
            "sessionHeaderData",
            JSON.stringify(data.data[0])
          );
          this.setState({ visitorPromocodeUrl: data.data[0][0].PromocodeLink, })
          sessionStorage.setItem("StallName", data.data[0][0].StallName)
          console.log(sessionStorage.getItem("ExhRegistrationIDSS"), 'data.data[0].StallName', data.data[0][0].StallName)
          if (data.data[0][0].CompanyName != '' && data.data[0][0].CompanyName != null) {
            var loginData = JSON.parse(sessionStorage.getItem("loginDataSS"))
            if (loginData != null) {
              loginData.CompanyName = data.data[0][0].CompanyName
              sessionStorage.setItem("loginDataSS", JSON.stringify(loginData))
            }
          }
          for (var i = 0; i < data.data[1].length; i++) {
            if (
              data.data[1][i].DownloadName == "Download Exhibitor Signature"
            ) {
              this.setState({
                isDownloadExhibitorSignature: data.data[1][i].Status,
              });
            } else if (
              data.data[1][i].DownloadName == "LETTER FROM VENUE KICC"
            ) {
              this.setState({ isLETTERFROMVENUEKICC: data.data[1][i].Status });
            } else if (data.data[1][i].DownloadName == "Download Material Exit pass") {
              this.setState({ isDownloadExitPass: data.data[1][i].Status });
            } else if (data.data[1][i].DownloadName == "Download E-Directory") {
              this.setState({ isDownloadEDirectory: data.data[1][i].Status });
            } else if (
              data.data[1][i].DownloadName == "Download Visitor Database"
            ) {
              this.setState({
                isDownloadVisitorDatabase: data.data[1][i].Status,
              });
            } else if (
              data.data[1][i].DownloadName == "Download Post Event Report"
            ) {
              this.setState({
                isDownloadPostEventReport: data.data[1][i].Status,
              });
            } else if (
              data.data[1][i].DownloadName == "Participation Certificate"
            ) {
              this.setState({
                isParticipationCertificate: data.data[1][i].Status,
              });
              sessionStorage.setItem(
                "isParticipationCertificateDashboard",
                data.data[1][i].Status
              );
            } else if (data.data[1][i].DownloadName == "No Dues certificate") {
              this.setState({ isNoDuescertificate: data.data[1][i].Status });
              sessionStorage.setItem(
                "isNoDuescertificateDashboard",
                data.data[1][i].Status
              );
            } else if (
              data.data[1][i].DownloadName == "Download Bonafide Certificate"
            ) {
              this.setState({
                isDownloadBonafideCertificate: data.data[1][i].Status,
              });
              sessionStorage.setItem(
                "isDownloadBonafideCertificate",
                data.data[1][i].Status
              );
            }
          }

          this.setState({
            isPowerDetailsFilled: data.data[4][0].isPowerDetailsFilled,
            isPowerFormFilled: data.data[4][0].isPowerFormFilled,
            isWaterDetailsFilled: data.data[4][0].isWaterDetailsFilled,
            isWaterFormFilled: data.data[4][0].isWaterFormFilled,
            isAirDetailsFilled: data.data[4][0].isAirDetailsFilled,
            isAirFormFilled: data.data[4][0].isAirFormFilled,
            isEdirectoryDetailsFilled: data.data[4][0].isEdirectoryDetailsFilled,
            isEdirectoryFormFilled: data.data[4][0].isEdirectoryFormFilled,
          })
          console.log('!data.data[4][0].isPowerDetailsFilled || !data.data[4][0].isPowerFormFilled || !data.data[4][0].isWaterDetailsFilled || !data.data[4][0].isWaterFormFilled || !data.data[4][0].isAirDetailsFilled || !data.data[4][0].isAirFormFilled || !data.data[4][0].isEdirectoryDetailsFilled || !data.data[4][0].isEdirectoryFormFilled', !data.data[4][0].isPowerDetailsFilled || !data.data[4][0].isPowerFormFilled || !data.data[4][0].isWaterDetailsFilled || !data.data[4][0].isWaterFormFilled || !data.data[4][0].isAirDetailsFilled || !data.data[4][0].isAirFormFilled || !data.data[4][0].isEdirectoryDetailsFilled || !data.data[4][0].isEdirectoryFormFilled)
          if (!data.data[4][0].isPowerDetailsFilled || !data.data[4][0].isPowerFormFilled || !data.data[4][0].isWaterDetailsFilled || !data.data[4][0].isWaterFormFilled || !data.data[4][0].isAirDetailsFilled || !data.data[4][0].isAirFormFilled || !data.data[4][0].isEdirectoryDetailsFilled || !data.data[4][0].isEdirectoryFormFilled) {
            if (sessionStorage.getItem("RoleIDSS") == 1) {
              this.setState({
                ManualFormAlert: true
              })
            }
          }

          setTimeout(() => {
            (sessionStorage.getItem('isIndirectAccess') && sessionStorage.getItem('isIndirectAccess') != null &&
              sessionStorage.getItem('isIndirectAccess') == 'true') || (sessionStorage.getItem('isPaidByAgentRegistration') != null && sessionStorage.getItem('isPaidByAgentRegistration') == 1) || (sessionStorage.getItem("RoleIDSS") != null && sessionStorage.getItem("RoleIDSS") == 8) ?
              this.setState({ toOpenManualForm: true })
              : (JSON.parse(sessionStorage.getItem('sessionHeaderData')) &&
                JSON.parse(sessionStorage.getItem('sessionHeaderData')) != null &&
                JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag'] != null &&
                (JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag']))
              && this.setState({ toOpenManualForm: true })
            this.getFillList(paymentMasterListActionId, '', '', '', '', '');
          }, 200);
          // console.log(data.data[0][0]['PendingAmount'].split(" "), 'data.data[0 ')
          // console.log(JSON.stringify(data.data[0][0]["PendingAmount"]).split(" ")[1].replace(/,/g, "") <= 0, 'data.data[0][0]["PendingAmount"] ')
          if (data.data[0][0]["PendingAmount"]) {
            if (data.data[0][0]["PendingAmount"].split(" ")[1]) {
              if (JSON.parse(data.data[0][0]["PendingAmount"].split(" ")[1].replace(/,/g, "")) <= 0) {
                console.log(JSON.parse(data.data[0][0]["PendingAmount"].split(" ")[1].replace(/,/g, "")) <= 0, 'data.data[0 ')
                sessionStorage.setItem("Is_100PercentPaid", true)
              } else {
                sessionStorage.setItem("Is_100PercentPaid", false)
              }
            } else {
              if (JSON.parse(data.data[0][0]["PendingAmount"]) <= 0) {
                sessionStorage.setItem("Is_100PercentPaid", true)
              } else {
                sessionStorage.setItem("Is_100PercentPaid", false)
              }
            }
          }
          this.setState({
            exhibitorDashboardList: data.data[0],
            isLoading: false,
            stall: data.data[0][0].StallName,
            is2ndPicreated: data.data[0][0].Is2ndPIgenerated,
            ExitPassDueDate: data.data[0][0].ExitPassDueDate,
            isNoDuesData: true,
            ndcissueDate: data.data[0][0].NDCIssuedDate != '' && data.data[0][0].NDCIssuedDate != null ? moment(data.data[0][0].NDCIssuedDate).format('DD MMM YYYY') : '',
            stallpossdate: data.data[0][0].PossessionTakenDate != '' && data.data[0][0].PossessionTakenDate != null ? moment(data.data[0][0].PossessionTakenDate).format('DD MMM YYYY') : '',
            exitdatecontractor: data.data[0][0].ContractorExitDate != '' && data.data[0][0].ContractorExitDate != null ? moment(data.data[0][0].ContractorExitDate).format('DD MMM YYYY') : '',
            exitdateExh: data.data[0][0].ExhibitorExitDate != '' && data.data[0][0].ExhibitorExitDate != null ? moment(data.data[0][0].ExhibitorExitDate).format('DD MMM YYYY') : '',
            IsHotelBookingFull: data.data[0][0].IsHotelBookingFull || false,
          });
          sessionStorage.setItem("conversionRate", data.data[0][0].ConversionRate)
          sessionStorage.setItem("additionalChargesUSDper", data.data[0][0].additionalChargesUSD)
          sessionStorage.setItem("companyName", data.data[0][0].CompanyName)
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Get Drawer Details
  getDrawerDetails() {
    this.setState({ isLoading: true });
    this.props
      .getDrawerDetails_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("Get getDrawerDetails", data.data);
          sessionStorage.setItem(
            "sessionExhibitorDrawerData",
            JSON.stringify(data.data)
          );
          var address =
            data.data[0] != null &&
            data.data[0] != "" &&
            data.data[0]["Address"] != null &&
            data.data[0]["Address"] != "" &&
            data.data[0]["Address"];
          var addArray = address != "" && address != null && address.split(",");
          sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray));
          this.setState({ isDrawerData: true, isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Circular Click
  onCircularsClick() {
    this.props.navigate("/exhCircularList", {
      state: { userFlag: "Exhibitor" },
    });
  }

  onHotelFormClick() {
    const { IsHotelBookingFull } = this.state
    if (IsHotelBookingFull) {
      this.props.navigate("/hotelEnquiry", {
        state: { from: "dashboard", exhID: sessionStorage.getItem('ExhRegistrationIDSS') },
      });
    } else {
      this.props.navigate("/hotelEnquiryForm", {
        state: { from: "dashboard", exhID: sessionStorage.getItem('ExhRegistrationIDSS') },
      });
    }
  }

  // On Download Signature Click
  // onDownloadSignature = async () => {
  //     this.setState({ isLoading: true })
  //     var list = [];
  //     const mapdata1 = {
  //         "ParameterName": "ExhibitionID",
  //         "ParameterValue": sessionStorage.getItem('sessionExhibitionID'),
  //         "ParameterDataType": "int"
  //     }
  //     const mapdata2 = {
  //         "ParameterName": "ExhRegistrationID",
  //         "ParameterValue": sessionStorage.getItem('ExhRegistrationIDSS'),
  //         "ParameterDataType": "int"
  //     }
  //     list.push(mapdata1);
  //     list.push(mapdata2);

  //     const mapData = {
  //         "report_name": signatureDocName,
  //         "parameter_details": list
  //     }
  //     const res = await axiosPost(fetchAuthReport, mapData);
  //     this.setState({ isLoading: false })
  //     if (res != null) {
  //         var url = `${downloadReport}?SessionIdentifier=${res}&Export=Yes`;
  //         const win = window.location.replace(url, '_blank');
  //         if (win != null) {
  //             win.focus();
  //         }
  //     }
  // }

  onDownloadSignature = async () => {
    const { exhibitorDashboardList } = this.state

    this.setState({ isLoading: true });
    try {
      // const data = await this.props.insertExhibitorBarcode_action();

      // if (data.error !== 1) {
      var list = [];
      const mapdata1 = {
        ParameterName: "@ExhibitionID",
        ParameterValue: parseInt(sessionStorage.getItem("sessionExhibitionID")),
        ParameterDataType: "int",
      };
      const mapdata2 = {
        ParameterName: "@ExhRegistrationID",
        ParameterValue: parseInt(sessionStorage.getItem("ExhRegistrationIDSS")),
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      list.push(mapdata2);
      const mapData = {
        report_name: exhibitorDashboardList.length > 0 ?
          exhibitorDashboardList[0]["ExhibitorSignatureReportName"] : '',
        parameter_details: list,
      };
      console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);

      const res = await axiosPost(fetchAuthReport, mapData);
      this.setState({ isLoading: false });

      if (res != null) {
        var url = `${downloadReport}?SessionIdentifier=${res}&Export=Yes`;
        const win = window.location.replace(url, "_blank");
        if (win != null) {
          win.focus();
        }
      }
      // } else {
      //     this.setState({ isLoading: false });
      //     toastError(data.msg);
      // }
    } catch (err) {
      console.error(err);
    }
  };

  onBonafiedDownloadClick = async () => {
    this.setState({ isLoading: true })
    var list = [];
    const mapdata1 = {
      ParameterName: "@ExhibitionID",
      ParameterValue: sessionStorage.getItem("sessionExhibitionID"),
      ParameterDataType: "int",
    };
    const mapdata2 = {
      ParameterName: "@ExhRegistrationID",
      ParameterValue: sessionStorage.getItem("ExhRegistrationIDSS"),
      ParameterDataType: "int",
    };

    list.push(mapdata1);
    list.push(mapdata2);

    const mapData = {
      report_name: bonafideDocName,
      parameter_details: list,
    };
    const res = await axiosPost(fetchAuthReport, mapData);
    this.setState({ isLoading: false, })

    if (res != null) {
      var url = `${downloadReport}?SessionIdentifier=${res}&Export=Yes`;
      const win = window.location.replace(url, "_blank");
      if (win != null) {
        win.focus();
      }
    }
  };

  onDownloadRegForm = async () => {
    this.setState({ isLoading: true })
    this.props.descriptionPreview_action(JSON.parse(sessionStorage.getItem('ExhRegistrationIDSS')))
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          console.log("ExhRegistration  Pdf Download", data)
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, '_blank');
          if (win != null) {
            win.focus();
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  };

  paymentDueNavigate() {
    this.props.navigate("/duePaymentsList", {
      // state: { userFlag: "Exhibitor" },
    });
  }

  downloadFileHotelEnquiry = () => {
    this.setState({ isLoading: true })
    // const url = `https://india-itme.com/document/Exhibition/HotelEnquiryForm/3/Hotel-Enquiry-Form.pdf`; // Replace with your file URL
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", "Hotel-Enquiry-Form.pdf"); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    setTimeout(() => {
      console.log("pppp")
      this.props
        .insertHotelEnquiryDownload_action(sessionStorage.getItem("ExhRegistrationIDSS"))
        .then((data) => {
          this.setState({ isLoading: false })
          if (data.error != 1) {
            // toastSuccess("Your space booking application has been submitted successfully.");
          }
          else {
            toastError(data.msg)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }, 500);
  };

  async onDocView(value) {
    // console.log(id);
    this.setState({ isLoading: true });
    try {

      var list = [];
      var mapdata1 = {}
      var mapData = {}
      mapdata1 = {
        "ParameterName": "@ExhRegistrationID",
        "ParameterValue": value,
        "ParameterDataType": "int"
      }
      list.push(mapdata1);
      mapData = {
        // "user_id": request.body.UserID,
        "report_name": 'ExhibitorRegistration.rpt',
        "parameter_details": list
      }
      console.log("xxxxxxxxxxxxxxxxxxxxx", mapData)
      const res = await axiosPost(fetchAuthReport, mapData);
      this.setState({ isLoading: false });

      if (res != null) {
        var url = `${downloadReport}?SessionIdentifier=${res}&Export=true`;
        // if (mode == 0) {
        //   const win = window.location.replace(url, "_blank");
        //   if (win != null) {
        //     win.focus();
        //   }
        // } else {
        const win = window.open(url, '_blank', 'noopener,noreferrer');
        if (win != null) {
          win.focus();
          // }
        }

      }
    } catch (err) {
      console.error(err);
    }
  }

  async onDocDownload(id, mode, value) {
    console.log(id);
    this.setState({ isLoading: true });
    try {

      var list = [];
      var mapdata1 = {}
      var mapData = {}
      if (id == 1) {
        mapdata1 = {
          "ParameterName": "@ExhRegistrationID",
          "ParameterValue": value,
          "ParameterDataType": "int"
        }
        list.push(mapdata1);
        mapData = {
          // "user_id": request.body.UserID,
          "report_name": 'ExhibitorRegistration.rpt',
          "parameter_details": list
        }
      } else if (id == 2) {
        mapdata1 = {
          "ParameterName": "@ExhRegistrationID",
          "ParameterValue": value,
          "ParameterDataType": "int"
        }
        list.push(mapdata1);
        mapData = {
          "report_name": JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? "1stInstallment_India.rpt" : "1stInstallment.rpt",
          "parameter_details": list
        }
      } else if (id == 3) {
        mapdata1 = {
          "ParameterName": "@ExhRegistrationID",
          "ParameterValue": value,
          "ParameterDataType": "int"
        }
        list.push(mapdata1);
        mapData = {
          "report_name": JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? "2ndInstallment_India.rpt" : "2ndInstallment.rpt",
          "parameter_details": list
        }
      } else if (id == 4) {
        mapdata1 = {
          "ParameterName": "@ExhRegistrationID",
          "ParameterValue": value,
          "ParameterDataType": "int"
        }
        list.push(mapdata1);
        mapData = {
          "report_name": JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? "Fullproforma_India.rpt" : "Fullproforma.rpt",
          "parameter_details": list
        }
      } else if (id == 5) {
        mapdata1 = {
          ParameterName: "@TaxInvoiceID",
          ParameterValue: this.state.txid,
          ParameterDataType: "int",
        }
        list.push(mapdata1);
        mapData = {
          report_name: "TaxInvoice.rpt",
          parameter_details: list,
        }
      } else if (id == 6) {
        mapdata1 = {
          ParameterName: "@ExhRegistrationID",
          ParameterValue: value,
          ParameterDataType: "int",
        }
        list.push(mapdata1);
        mapData = {
          report_name: "Outstanding.rpt",
          parameter_details: list,
        }
      } else if (id == 7) {
        mapdata1 = {
          ParameterName: "@ExhibitionID",
          ParameterValue: sessionStorage.getItem("sessionExhibitionID"),
          ParameterDataType: "int",
        }
        list.push(mapdata1);
        mapdata1 = {
          ParameterName: "@ExhRegistrationID",
          ParameterValue: value,
          ParameterDataType: "int",
        }
        list.push(mapdata1);
        mapData = {
          report_name: "ExhibitorSignature.rpt",
          parameter_details: list,
        }
      }
      console.log("xxxxxxxxxxxxxxxxxxxxx", mapData)
      const res = await axiosPost(fetchAuthReport, mapData);
      this.setState({ isLoading: false });

      if (res != null) {
        var url = `${downloadReport}?SessionIdentifier=${res}&Export=true`;
        if (mode == 0) {
          const win = window.location.replace(url, "_blank");
          if (win != null) {
            win.focus();
          }
        } else {
          const win = window.open(url, '_blank', 'noopener,noreferrer');
          if (win != null) {
            win.focus();
          }
        }

      }
    } catch (err) {
      console.error(err);
    }
  }

  downloadUndertaking() {
    const url = `${DOC_BASE_URL}/document/Exhibition/undertaking/${sessionStorage.getItem("sessionExhibitionID")}/Undertaking_${sessionStorage.getItem("sessionExhibitionID")}.pdf`
    const win = window.location.replace(url, "_blank");
    if (win != null) {
      win.focus();
    }
  }

  getManualFormsList() {
    this.setState({ isLoading: true });
    this.props
      .getManualForms_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("getManualForms_action", data);
          if (data.data.length > 0) {
            const today = new Date();
            const MFDeadlineDays = data.data[0]["MFDeadlineDays"] || 0;

            // check deadlines within 3 days
            const dueSoon = data.data.filter((item) => {
              const deadline = new Date(item.Deadline);
              const diffTime = deadline - today;
              const diffDays = diffTime / (1000 * 60 * 60 * 24); // convert ms → days
              return diffDays >= -1 && diffDays < MFDeadlineDays - 1;
            });

            // console.log("Forms due within 3 days:", dueSoon);
            this.setState({
              List: data.data,
              AllManualFormList: data.data,
              isLoading: false,
              OverDueFormCount: dueSoon.length,
              OverDueFormCountList: dueSoon,
              MFDeadlineDays: MFDeadlineDays,
            });
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setTimeout(() => {
      console.log(this.state.List);
    }, 200);
  }

  getManageAreaList() {
    this.setState({ isLoading: true })
    this.props.getManageAreaList_action(sessionStorage.getItem("sessionExhibitionID"))
      .then((data) => {
        if (data.error != 1) {
          console.log(data.data)
          // this.setState({ installmentList: [] })
          this.setState({ isLoading: false, installment1stDate: data.data.installmentList[0].CutOffDate != null && data.data.installmentList[0].CutOffDate != '' ? (moment(data.data.installmentList[0].CutOffDate).format('DD MMM YYYY')) : '', installment2ndDate: data.data.installmentList[1].CutOffDate != null && data.data.installmentList[1].CutOffDate != '' ? moment(data.data.installmentList[1].CutOffDate).format('DD MMM YYYY') : '' })
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getCircularList() {
    this.setState({ isLoading: true })
    this.props.getExhibitorCircularList_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("getCircularList Data", data.data)
          this.setState({
            circularList: data.data,
            isLoading: false,
          })
        } else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getExhibitorExitPassDetails(UUID, exhibitionID) {
    const {
      ContractorId,
      isView,
      exitPassId,
      extraServices,
      isApproved,
      ExitPassStatus,
    } = this.state;
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true });
      console.log("ContractorId--------->", ContractorId);

      this.props
        .getExhibitorExitPassDetails_action(
          null,
          null,
          sessionStorage.getItem("sessionExhibitionID")
        )
        .then((data) => {
          if (data.error != 1) {
            if (data.data.length > 0) {
              this.setState({
                showExitPass: sessionStorage.getItem("RoleIDSS") == 1 ? data.data[0][0]['IsEntryFill'] : false
              })

              const array = [];
              data.data[1].forEach((item) => {
                item.itemToCarryList = data.data[2].filter(
                  (obj) => obj.ExhExitPassHdrID === item.ExhExitPassHdrID
                );
                array.push(item);
                // if (item.ExitPassStatus == "Approved") {
                //   tempApproveFlag = true;
                // }
              });
              this.setState({
                formStatus: array.length > 0 ? array[array.length - 1].ExitPassStatus : 'Not Filled',
                deadline: '',
              })

              console.log('Previous Material Exit passesPrevious Material Exit passes', array)
              resolve(true);
            }
            this.setState({ isLoading: false });
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });

    });
  }

  getTaxInvoiceList() {
    const { exhibitorCompany, ReferenceNo, taxInvoiceNo } =
      this.state;
    this.setState({ isLoading: true });
    this.props
      .taxInvoiceList_action(
        exhibitorCompany, sessionStorage.getItem("ExhRegistrationNo"), taxInvoiceNo
      )
      .then((data) => {
        if (data.error != 1) {
          var list = [...data.data]
          // list.map((item, index) => {
          //   item.isSelect = 0;
          // });
          for (var i = 0; i < list.length; i++) {
            if (list[i].ServiceName == 'Space Booking') {
              this.setState({ txid: list[i].TaxInvoiceID })
            }
          }
          // data.data = data.data.map(item => ({ ...item, Is_checked: 0 }));
          // console.log("from UI Client", list);
          // this.setState({
          //   taxInvoiceData: list,
          //   allSelected: false,
          //   isLoading: false,
          // });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getLedgerList() {
    const { fromAmount, toAmount, accountTypeId, currencyId, exhibitorId, exhibitorTypeId, reminderTypeId } = this.state
    this.setState({ isLoading: true })
    this.props.getLedgerList_action(JSON.parse(sessionStorage.getItem('ExhRegistrationIDSS')), accountTypeId, currencyId, fromAmount, toAmount,
      exhibitorTypeId != "" && exhibitorTypeId != "Select Exhibitor Type" ? exhibitorTypeId : "", reminderTypeId)
      .then((data) => {
        if (data.error != 1) {
          data.data != '' && data.data != null ?

            data.data.map((item) => {
              if (item.ExhRegistrationID == sessionStorage.getItem("ExhRegistrationIDSS")) {
                this.setState({ isFull: true })
              }
            })

            : <></>

        } else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })

  }

  navToMf(id) {
    this.props.navigate("/manualForms", {
      state: { dash: true, isClicked: id },
    });
  }

  handleConfirmation(flag) {
    const { confirmationObj } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.onDocView(sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 1) {
        this.onDocDownload(1, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 2) {
        this.onDownloadSignature()
      }
      if (confirmationObj.action == 3) {
        this.downloadUndertaking()
      }
      if (confirmationObj.action == 4) {
        this.onDocDownload(2, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 5) {
        this.onDocDownload(3, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 6) {
        this.onDocDownload(4, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 7) {
        this.onDocDownload(5, 0, this.state.txid)
      }
      if (confirmationObj.action == 8) {
        this.onDocDownload(6, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
      if (confirmationObj.action == 9) {
        const url = BASE_URL.split("/api")[0] + '/document/Exhibition/ExhibitorChecklist/3/Exhibitor_Checklist_for_successful_&_smooth_participation.pdf';
        window.open(url, '_blank', 'noopener,noreferrer');
      }
      if (confirmationObj.action == 10) {
        this.onDocDownload(7, 0, sessionStorage.getItem("ExhRegistrationIDSS"))
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  handleOpenForm(flag) {
    const { namePrefix, isSSifileType, AllManualFormList, ExhibitDetailsNote, selectedPrimaryChapterIdList, internationalAreaSlabList, TMMAITAMMAfileType } = this.state
    var item = {}
    console.log(flag, AllManualFormList)
    for (var i = 0; i < AllManualFormList.length; i++) {
      if (AllManualFormList[i].ManualFormID == flag) {
        item = AllManualFormList[i]
        break
      }
    }
    var ID = item.ManualFormID
    var deadline = item.Deadline
    var StatusID = item.StatusID
    var name = item.Name
    var ServiceID = item.ServiceID
    var isVendorSelectionAllowed = item.isVendorSelectionAllowed
    var IsNonEmpanelCard = item.IsNonEmpanelCard

    const deadlineState = sessionStorage.getItem("isIndirectAccess") == "true" ? null : deadline;

    const obj = {
      CompanyName: item.VendorCompanyName,
      PersonName: item.VendorName,
      EmailID: item.VendorEmail,
      MobileNo: item.VendorMobileNo,
      VendorMDName: item.VendorMDName != ' ' ? item.VendorMDName : null,
      VendorMDMobileNo: item.VendorMDMobileNo,
      VendorMDEmaiId: item.VendorMDEmaiId,
    }

    if (isVendorSelectionAllowed && (StatusID == 0 || StatusID == 3)) {
      this.props.navigate("/manualFormsVendorList", {
        state: {
          Deadline: deadline,
          StatusID: StatusID != 2 ? StatusID : (sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID),
          ManualFormsID: ID,
          ManualFormsName: name,
          ServiceID: ServiceID,
          ActualDeadline: deadline,
          isVendorSelectionAllowed,
          VendorDetails: obj,
          IsNonEmpanelCard,
          DeadlineDate: "",
          currentDate: moment().format("DD-MM-YYYY"),
          VendorDetailShow: item.isITMEBilling == 0 ? obj : null,
          isITMEBilling: item.isITMEBilling
        },
      });
    } else {
      const routeMap = {
        5: "/edirectoryList",
        10: "/powerConnection",
        12: "/water",
        13: "/airConnectionApplication",
      };
      const path = routeMap[ID];
      this.props.navigate(path, {
        state: {
          Deadline: deadlineState,
          VendorDetails: obj,
          is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
          Is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
          ActualDeadline: deadline,
          StatusID: StatusID != 2 ? StatusID : (sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID),
          ManualFormsID: ID,
          ServiceID: ServiceID,
          VendorDetailShow: item.isITMEBilling == 0 ? obj : null,
          isITMEBilling: item.isITMEBilling
        },
      });
    }
  }

  render() {
    const { isLoading, downloadAll, exhibitorDashboardList, ExitPassDueDate, isDownloadExhibitorSignature, isDrawerData, isNoDuesData, List, AllManualFormList, OverDueFormCount, OverDueFormCountList, MFDeadlineDays, circularList, PendingExhManualFormCount, PendingExhManualFormList,
      creditData, ndcissueDate,
      stallpossdate,
      exitdateExh,
      exitdatecontractor, toOpenManualForm, makePay, isOpenConfirmationModal, ExitPassDamageList } =
      this.state;

    // Group ExitPassDamageList by ExhExitPassHdrID
    const damageGroupsMap = {};
    ExitPassDamageList.forEach(item => {
      if (!damageGroupsMap[item.ExhExitPassHdrID]) {
        damageGroupsMap[item.ExhExitPassHdrID] = { ExitNo: item.ExitNo, ExhExitPassHdrID: item.ExhExitPassHdrID, Remark: item.Remark, docs: [] };
      }
      damageGroupsMap[item.ExhExitPassHdrID].docs.push(item.DocumentPath);
    });
    const damageGroups = Object.values(damageGroupsMap);
    const firstDamageGroup = damageGroups[0] || null;
    const sessionHeaderData = JSON.parse(
      sessionStorage.getItem("sessionHeaderData")
    );

    const HallName = exhibitorDashboardList?.[0]?.["HallNo"] || null;

    const getHallPdf = (hallNames) => {
      const halls =
        hallNames?.match(/\d+/g)?.map(Number) || [];

      if (halls.some((h) => [2].includes(h))) {
        return "hall-2.pdf";
      }

      if (halls.some((h) => [1, 3, 5, 7].includes(h))) {
        return "hall-1-3-5-7.pdf";
      }

      if (halls.some((h) => [9, 10, 11, 12].includes(h))) {
        return "hall-9-10-11-12.pdf";
      }

      if (halls.some((h) => [14, 15, 16, 17].includes(h))) {
        return "hall-14-15-16-17.pdf";
      }

      return null;
    };
    // console.log("country data", sessionHeaderData,
    //   sessionHeaderData[0],
    //   sessionHeaderData[0]["Is_100PercentPaid"],
    //   sessionHeaderData[0]["Bonafide Certificate"] == "Yes")

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        {downloadAll && <>
          <div class="overlayFordashboard">
            {/* <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> */}
          </div>
        </>}
        {downloadAll && <div tyle={{ backgroundColor: '#57c4b2' }} class="drawer open" id="drawer open" style={{ zIndex: '999999' }}>
          <span onClick={() => this.setState({ downloadAll: false })} class="close-btn" id="closeDrawer">&times;</span>
          <h5 style={{ backgroundColor: '#57c4b2' }}><i class="bi bi-download download-icon text-white"></i> &nbsp; Download Center</h5>

          <div class="doc-document">
            <div class="doc-list mt-1">
              {/* <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }} >
                    <h6>Exhibitor signature</h6>
                    <small >PDF</small>
                  </div>
                </div>
                <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Signature', buttonName: 'Download', action: 2 } })
                } class="bi bi-download download-icon"></i>

              </div> */}


              {/* <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Undertaking Form</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Undertaking Form', buttonName: 'Download', action: 3 } })} class="bi bi-download download-icon"></i>
              </div> */}

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Bonafide certificate</h6>
                    <small>PDF</small>
                  </div>
                </div>
                {(sessionHeaderData &&
                  sessionHeaderData[0] &&
                  (sessionStorage.getItem("Is_100PercentPaid") ||
                    sessionHeaderData[0]["Bonafide Certificate"] == "Yes")) ||
                  JSON.parse(
                    sessionStorage.getItem("isDownloadBonafideCertificate")
                  ) == true ? <i class="bi bi-download download-icon"></i> : <div class="info-icon-wrapper">
                  <i class="bi bi-info-circle info-icon"></i>
                  <span class="tooltip-text">
                    The download will be enabled only after 100% payment has been made.
                  </span> </div>
                }
              </div>

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Registration Form</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 1 } })}
                  // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 2 } })} 
                  class="bi bi-download download-icon"></i>
              </div>

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>1st Proforma Invoice</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download 1st Proforma Invoice', buttonName: 'Download', action: 4 } })} class="bi bi-download download-icon"></i>
                {/* <div class="info-icon-wrapper">
                  <i class="bi bi-info-circle info-icon"></i>
                  <span class="tooltip-text">
                    The Proforma  Invoice  download  facility  is temporarily  is unavailable. As our team is currently  reviewing the updates  submitted  you in the application.
                  </span> </div> */}
              </div>

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>2nd Proforma Invoice</h6>
                    <small>PDF</small>
                  </div>
                </div>

                {this.state.is2ndPicreated ? <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download 2nd Proforma Invoice', buttonName: 'Download', action: 5 } })} class="bi bi-download download-icon"></i>
                  : <div class="info-icon-wrapper">
                    <i class="bi bi-info-circle info-icon"></i>
                    <span class="tooltip-text">
                      The download will be enabled only after 2nd PI has been created.
                    </span> </div>
                }

                {/* <div class="info-icon-wrapper">
                  <i class="bi bi-info-circle info-icon"></i>
                  <span class="tooltip-text">
                    The Proforma  Invoice  download  facility  is temporarily  is unavailable. As our team is currently  reviewing the updates  submitted  you in the application.
                  </span> </div> */}
              </div>

              {/* <div class="doc-item">
                  <div class="doc-info">
                    <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                    <div class="doc-text" style={{ textAlign: 'left' }}>
                      <h6>Full Proforma Invoice</h6>
                      <small>PDF</small>
                    </div>
                  </div>
                  {this.state.isFull ? <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Full Proforma Invoice', buttonName: 'Download', action: 6 } })} class="bi bi-download download-icon"></i> : <div class="info-icon-wrapper">
                    <i class="bi bi-info-circle info-icon"></i>
                    <span class="tooltip-text">
                      The download will be enabled only after Tax Invoice has been created.
                    </span> </div>
                  }

                </div> */}

              {/*  <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Tax Invoice</h6>
                    <small>PDF</small>
                  </div>
                </div>
                {this.state.txid == '' ? <div class="info-icon-wrapper">
                  <i class="bi bi-info-circle info-icon"></i>
                  <span class="tooltip-text">
                    The download will be enabled only after Tax Invoice has been created.
                  </span> </div> : (moment(sessionStorage.getItem('CurrentDateSS')).isSameOrAfter(moment(sessionStorage.getItem('ExhibitionFromDateSS'))) ? <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Tax Invoice', buttonName: 'Download', action: 7 } })} class="bi bi-download download-icon"></i> : <div class="info-icon-wrapper">
                    <i class="bi bi-info-circle info-icon"></i>
                    <span class="tooltip-text">
                      The download will be enabled after the exhibition starts.
                    </span> </div>)
                }
              </div>*/}

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Ledger</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Ledger?', buttonName: 'Download', action: 8 } })}
                  // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 2 } })} 
                  class="bi bi-download download-icon"></i>
              </div>

              {/* <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Exhibitor Signature</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Exhibitor Signature?', buttonName: 'Download', action: 10 } })}
                  class="bi bi-download download-icon"></i>
              </div> */}

              <div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>Exhibitor Checklist for successful & smooth participation</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Exhibitor Checklist for successful & smooth participation?', buttonName: 'Download', action: 9 } })}
                  // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 2 } })} 
                  class="bi bi-download download-icon"></i>
              </div>

              {/*<div class="doc-item">
                <div class="doc-info">
                  <i class="bi bi-file-earmark-pdf text-primary doc-icon"></i>
                  <div class="doc-text" style={{ textAlign: 'left' }}>
                    <h6>No Due Certificate</h6>
                    <small>PDF</small>
                  </div>
                </div>
                <i class="bi bi-download download-icon"></i>
              </div> */}

              {/* <button type="btn" class="btn btn-primary down-btn mx-2">Download All Documents</button> */}
            </div>
          </div>
        </div >}
        <ToastContainer />
        <ExhibitorHeader />
        {isDrawerData && isNoDuesData ? <ExhibitorDrawer /> : null}
        {/*app-content open*/}
        <div className="page">
          <div className="page-main">
            <div className="main-content  with-dr-container">
              {/* <div className="container-fluid">
                                <div className="row">
                                    <div className="tab-scroll-fixed">
                                <p>Exhibitor Dashboard</p>
                            </div>
                                    <ExhibitorTopMenu />
                                </div>
                            </div> */}
              <div className="">
                <div className=" width-dr-nav">
                  <div className="row">
                    {sessionStorage.getItem("RoleIDSS") == 1 ? JSON.parse(sessionStorage.getItem('sessionHeaderData')) ? <ExhibitorTopMenu /> : null : <ExhibitorTopMenu />}
                  </div>
                </div>
                <div className="p-2 pt-1 mt-3 exh-dash-grid">
                  <div className="row ms-2">

                    <div class="row gy-4">

                      {/* <!-- Application Details --> */}
                      <div class="col-md-4">
                        <div class="card shadow-none h-100-box">
                          <div class="card-body rounded-2">
                            <div class="d-flex justify-content-between align-items-center">
                              <h6 class="card-title fw-semibold pt-1 pb-1">
                                <i class="bi bi-journal-text text-primary me-2"></i> Application Details
                              </h6>
                              <div>
                                <a onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to View Application Details', buttonName: 'View', action: 0 } })
                                  //  this.onDocView(sessionStorage.getItem("ExhRegistrationIDSS"))
                                } class="text-primary fw-semibold me-3" title="View Application">
                                  <i class="bi bi-eye fs-6"></i>
                                </a>
                                <a onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Application Details', buttonName: 'Download', action: 1 } })
                                  //  this.onDocView(sessionStorage.getItem("ExhRegistrationIDSS"))
                                } class="text-primary fw-semibold" title="Download Application">
                                  <i class="bi bi-download fs-6"></i>
                                </a>
                              </div>
                            </div>

                            <div class="row mt-2">
                              <div class="col-6">
                                <div class="p-2 rounded card-bg-col h-100">
                                  {/* <div class="circle-logo single-color text-white mb-1">{sessionStorage.getItem("firstNameSS")[0]}</div> */}
                                  <h6 class="text-muted ">Application Reference No</h6>
                                  <h6 class="semibold mt-1 ">{exhibitorDashboardList.length > 0 &&
                                    exhibitorDashboardList[0]["ExhRegistrationNo"]}</h6>
                                </div>
                              </div>

                              <div class="col-6">
                                <div class="p-2 card-bg-col rounded h-100" style={{ textAlign: 'left' }}>
                                  {/* <div class="circle-logo mb-1">{sessionStorage.getItem("lastNameSS")[0]}</div> */}
                                  <h6 class="text-muted">Booking Status</h6>
                                  <div class="badge single-color mt-2 fw-normal pb-1">{exhibitorDashboardList.length > 0 &&
                                    exhibitorDashboardList[0]["StatusID"] == 4
                                    ? "Applied"
                                    : "-"}</div>
                                </div>
                              </div>
                            </div>


                            <div class="row mt-3">
                              {/* <div class="col-6">
                                <div class="p-3 card-bg-col rounded h-100">
                                  <h6>Priority No</h6>
                                  <h6 class="semibold mt-1">{exhibitorDashboardList.length > 0 &&
                                    exhibitorDashboardList[0]["PriorityNo"]}</h6>
                                </div>
                              </div> */}
                              <div class="col-6">
                                <div class="px-2 py-3 card-bg-col rounded h-100" style={{ textAlign: 'left' }}>
                                  <h6 class="text-muted">Primary Chapter</h6>
                                  <div class="badge single-color mt-2 fw-normal pb-1"> {exhibitorDashboardList.length > 0 &&
                                    exhibitorDashboardList[0]["MainCategory"] != '' && exhibitorDashboardList[0]["MainCategory"] != null ? exhibitorDashboardList[0]["MainCategory"] : '-'}</div>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="px-2 py-3 card-bg-col rounded h-100" style={{ textAlign: 'left' }}>
                                  <span className="d-flex" style={{ justifyContent: 'space-between' }}
                                  > <h6 class="text-muted">Venue Layout</h6>
                                    <a class="text-primary fw-semibold me-3" title="View Venue Layout"
                                      onClick={() => {
                                        const url = `${BASE_URL.split('/api')?.[0]}/document/Exhibition/layoutView/3/venue-layout.pdf`;
                                        window.open(url, "_blank", "noopener,noreferrer");
                                      }}
                                    >
                                      <i class="bi bi-eye fs-6"></i>
                                    </a>
                                  </span>
                                  {HallName ?
                                    <span className="d-flex" style={{ justifyContent: 'space-between' }}> <h6 class="text-muted">Hall Layout</h6>
                                      <a class="text-primary fw-semibold me-3" title="View Hall Layout"
                                        onClick={() => {
                                          const pdf = getHallPdf(HallName);

                                          if (!pdf) return;

                                          const url = `${BASE_URL.split("/api")[0]}/document/Exhibition/layoutView/3/${pdf}`;
                                          window.open(url, "_blank", "noopener,noreferrer");
                                        }}
                                      >
                                        <i class="bi bi-eye fs-6"></i>
                                      </a>
                                    </span> : ''
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row mt-3">
                              {/* <div class="col-6">
                                <div class="p-3 card-bg-col rounded h-100">
                                  <h6>Priority No</h6>
                                  <h6 class="semibold mt-1">{exhibitorDashboardList.length > 0 &&
                                    exhibitorDashboardList[0]["PriorityNo"]}</h6>
                                </div>
                              </div> */}
                              <div class="col-12">
                                {/* Promo code banner (promo-code-banner in responsive-fixes.css): teal, icon, text, View Code button */}
                                <div class="promo-code-banner h-100">
                                  <span class="promo-code-banner-icon" aria-hidden="true">
                                    <i class="bi bi-percent"></i>
                                  </span>
                                  <div class="promo-code-banner-text">
                                    <h6 class="promo-code-banner-title">Promo code for Visitor Registration</h6>
                                  </div>
                                  <button type="button" class="promo-code-banner-btn" title="View Promo Code"
                                    onClick={() => {
                                      const url = this.state.visitorPromocodeUrl;
                                      window.open(url, "_blank", "noopener,noreferrer");
                                    }}
                                  >
                                    View Code <i class="bi bi-arrow-right"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      {/* <!-- Booth Details --> */}
                      <div class="col-md-4">
                        <div class="card shadow-none h-100-box">
                          <div class="card-body rounded-2">
                            <h6 class="card-title fw-semibold pt-1 pb-1">
                              <i class="bi bi-grid text-primary me-2"></i> Booth Details
                            </h6>
                            <div class="row mt-3" style={{ textAlign: 'center' }}>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100">
                                  <i class="bi bi-geo-alt fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Hall Name</small>
                                  <h6 class="semibold mt-1 " style={{ textAlign: 'center' }}>{exhibitorDashboardList.length > 0 ?
                                    exhibitorDashboardList[0]["HallNo"] != '' && exhibitorDashboardList[0]["HallNo"] != null ? exhibitorDashboardList[0]["HallNo"] : 'NA' : 'NA'}</h6>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100">
                                  <i class="bi bi-layout-text-window-reverse fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Stall Allocated</small>
                                  <h6 class="semibold mt-1 " style={{ textAlign: 'center' }}> {exhibitorDashboardList.length > 0 ?
                                    exhibitorDashboardList[0]["BothAllotted"] != '' && exhibitorDashboardList[0]["BothAllotted"] != null ? exhibitorDashboardList[0]["BothAllotted"] : 'NA' : 'NA'}</h6>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100">
                                  <i class="bi bi-arrows-expand fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Open Sides</small>
                                  <h6 class="semibold mt-1 " style={{ textAlign: 'center' }}>{exhibitorDashboardList.length > 0 ? exhibitorDashboardList[0]["OpenSides"] != '' && exhibitorDashboardList[0]["OpenSides"] != 0 && exhibitorDashboardList[0]["OpenSides"] != null ? exhibitorDashboardList[0]["OpenSides"] : 'NA' : 'NA'}</h6>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-3" style={{ textAlign: 'center' }}>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100 ">
                                  <i class="bi bi-grid-3x3 fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Stall Area</small>
                                  <h6 className="semibold mt-1 " style={{ textAlign: 'center' }}>
                                    {exhibitorDashboardList.length > 0 && (
                                      exhibitorDashboardList[0]["StallArea"] != 0 && exhibitorDashboardList[0]["StallArea"] != null ? <>
                                        {exhibitorDashboardList[0]["StallArea"]}m
                                        <sup>2</sup>
                                        <br />
                                        ({exhibitorDashboardList[0]["ExhibitionStallDimension"]})
                                      </> : 'NA'
                                    )}
                                  </h6>

                                </div>
                              </div>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100">
                                  <i class="bi bi-bounding-box fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Stall Type</small>
                                  <h6 class="semibold mt-1 " style={{ textAlign: 'center' }}>{exhibitorDashboardList.length > 0 ? exhibitorDashboardList[0]["StallTypeName"] : ''}</h6>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="p-2 card-bg-col rounded text-center h-100">
                                  <i class="bi bi-building fs-4 single-color-text"></i><br />
                                  <small class="text-muted">Double Storey Area</small>
                                  <h6 class="semibold mt-1 " style={{ textAlign: 'center' }}> {exhibitorDashboardList.length > 0 ? exhibitorDashboardList[0]["DoubleStoreyArea"] !=
                                    null &&
                                    exhibitorDashboardList[0]["DoubleStoreyArea"] !=
                                    "" ? (
                                    <>
                                      {
                                        exhibitorDashboardList[0][
                                        "DoubleStoreyArea"
                                        ]
                                      }
                                      m<sup>2</sup>
                                    </>
                                  ) : (
                                    'NA'
                                  ) : ''}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <!-- Manual Forms Status --> */}
                      <div class="col-md-4">
                        <div class="card shadow-none h-100-box">
                          <div class="card-body rounded-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="card-title fw-semibold pt-1 pb-1">
                                <i class="bi bi-clipboard-check text-primary me-2"></i> Manual Forms Status
                              </h6>
                              <button onClick={(e) => this.onHotelFormClick(e)} class="btn btn-sm px-3 hotel-booking"> Hotel Enquiry Form </button>
                            </div>



                            {/* <!-- Row 1 --> */}
                            <div class="row mt-2">
                              <div class="col-4 text-center">
                                <div onClick={() => toOpenManualForm ? this.navToMf(1) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ width: '40px', cursor: 'pointer', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{
                                      AllManualFormList.filter((item) => item.FormType == "Mandatory")
                                        .length
                                    }</div>
                                  <small class="text-muted d-block mt-1">Total Mandatory</small>
                                </div>
                              </div>

                              <div class="col-4 text-center">
                                <div onClick={() => toOpenManualForm ? this.navToMf(2) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{
                                      AllManualFormList.filter((item) => item.Status == "Approved")
                                        .length
                                    }</div>
                                  <small class="text-muted d-block mt-1">Completed</small>
                                </div>
                              </div>

                              <div class="col-4 text-center">
                                <div onClick={() => toOpenManualForm ? this.navToMf(3) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{
                                      AllManualFormList.filter((item) => item.Status == "Applied")
                                        .length
                                    }</div>
                                  <small class="text-muted d-block mt-1">Under Process</small>
                                </div>
                              </div>
                            </div>

                            {/* <!-- Row 2 --> */}
                            <div class="row mt-3">
                              <div class="col-4 text-center position-relative">
                                <div onClick={() => toOpenManualForm ? this.navToMf(4) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{
                                      AllManualFormList.filter((item) => (item.Deadline >= new Date()) && item.Deadline <= new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000))
                                        .length
                                    }
                                  </div>
                                  <small class="text-muted d-block mt-1">Due in 30 Days</small>
                                </div>
                              </div>

                              <div class="col-4 text-center">
                                <div onClick={() => toOpenManualForm ? this.navToMf(5) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{
                                      AllManualFormList.filter((item) => (new Date(item.Deadline) < new Date()))
                                        .length
                                    }</div>
                                  <small class="text-muted d-block mt-1">Overdue</small>
                                </div>
                              </div>

                              <div class="col-4 text-center">
                                <div onClick={() => toOpenManualForm ? this.navToMf(6) : null} class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>{PendingExhManualFormCount}</div>
                                  <small class="text-muted d-block mt-1">Pending Mandatory Form</small>
                                </div>
                              </div>
                              {/* <div class="col-4 text-center">
                                <div class="p-3 rounded card-bg-col h-100">
                                  <div class="single-color-border mx-auto d-flex align-items-center justify-content-center text-muted"
                                    style={{ width: '40px', height: '40px', borderRadius: '50%', fontWeight: '600' }}>12</div>
                                  <h6 class="text-muted d-block mt-1">Vendor Accepted</h6>
                                </div>
                              </div> */}
                            </div>

                          </div>
                        </div>
                      </div>
                      {/* <!-- Payment Info --> */}
                      {sessionStorage.getItem("RoleIDSS") != 8 && <div class="col-md-4">
                        <div class="card shadow-none border-0 h-100-box">
                          <div class="card-body rounded-2">
                            <h6 class="card-title fw-semibold pt-2 pb-2">
                              <i class="bi bi-credit-card text-primary me-2"></i> Payment Info
                            </h6>
                            <div class="rounded text-right">
                              <h6>
                                <b class="semibold mb-0 text-end">Payment Due Date: </b><span class="text-danger  fw-semibold">{this.state.is2ndPicreated ? this.state.installment2ndDate : this.state.installment1stDate} {this.state.is2ndPicreated ? '(2nd Installment)' : '(1st Installment)'}
                                </span>
                              </h6>
                            </div>
                            <div class="row mt-3 border-2">
                              <div class="col-6">
                                <div class="p-3 rounded text-center" style={{ border: '1px solid #f8d8da' }}>
                                  <h5 class="semibold mb-0" style={{ color: "#21b0a4" }}>{JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? '₹' : '$'} {exhibitorDashboardList.length > 0 && exhibitorDashboardList[0]["PaidAmount"] != null &&
                                    exhibitorDashboardList[0]["PaidAmount"].toLocaleString(
                                      "en-IN"
                                    )}</h5>
                                  <small class="text-muted">Paid Amount </small>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="p-3  rounded text-center" style={{ border: '1px solid #f8d8da' }}>
                                  <h5 class="semibold mb-0" style={{ color: "#21b0a4" }}>{JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? '₹' : '$'} {exhibitorDashboardList.length > 0 && exhibitorDashboardList[0]["TotalAmount"] != null &&
                                    exhibitorDashboardList[0]["TotalAmount"].toLocaleString(
                                      "en-IN"
                                    )}</h5>
                                  <small class="text-muted">Total Bill Amount</small>
                                </div>
                              </div>
                            </div>
                            <div class="p-3 py-1 mb-3 border-1 rounded-3 " style={{ border: '1px solid #f8d8da' }}>
                              <div class="d-flex align-items-center mb-2">
                                <i class="bi bi-exclamation-circle me-2 text-danger"></i>
                                <h6 class="text-danger fw-semibold">Outstanding Payment</h6>
                              </div>
                              <h4 class="semibold text-danger mb-0" style={{ textAlign: 'left' }}>
                                {/* { JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91?'₹':'$'}  */}
                                {exhibitorDashboardList.length > 0 &&
                                  exhibitorDashboardList[0]["PendingAmount"]}</h4>
                              <h6 class="text-muted">Payment Due</h6>
                            </div>
                            {exhibitorDashboardList.length > 0 && <div class="d-flex justify-content-between mt-2">
                              <button onClick={() => this.paymentDueNavigate()} disabled={!makePay || exhibitorDashboardList[0]["PaidAmount"] == exhibitorDashboardList[0]["TotalAmount"]} class="btn btn-aqua w-50 me-2">Make Payment</button>
                              <button onClick={() => this.props.navigate("/receiptlist", {})} class="btn btn-outline-dark w-50">
                                <i class="bi bi-calendar me-2"></i>Payment History
                              </button>
                            </div>}


                          </div>
                        </div>
                      </div>}

                      {/* <!-- Messages --> */}
                      <div class="col-md-4">
                        <div class="card shadow-none border-0 h-100-box">
                          <div class="card-body rounded-2 d-flex flex-column">

                            {/* <!-- Heading + Count on Right --> */}
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="card-title fw-semibold pt-2 pb-2 m-0">
                                <i class="bi bi-chat-left text-primary me-2"></i> Messages and Circulars
                              </h6>
                              <span class="badge custom-badge rounded-pill" style={{ border: '1px solid #0e266e', color: '#0e266e' }}>{this.state.circularList.length}
                              </span>
                            </div>

                            {/* <!-- Message Box 1 --> */}
                            {/* Messages scroll inside the card, so the card stays the height of its row */}
                            <div className="dash-msg-list">
                              {circularList.length > 0 && circularList.map(item => (
                                <a style={{ cursor: 'pointer' }} class="d-flex align-items-start justify-content-between mb-2">
                                  <div className="text-primary"
                                    href={item.Attachment}
                                    target="_blank"
                                    rel="noopener noreferrer" class="d-flex  rounded w-100 p-0">

                                    <i class="bi bi-bell text-primary fs-5 me-2"></i>
                                    <div>
                                      <h6 class="fw-semibold">{item.subject}</h6>
                                      {/* <h6 class="text-muted">Setup guidelines for booth construction</h6><br /> */}
                                      <h6 class="text-muted"><i class="bi bi-calendar"></i> {moment(item.CircularDate).format('DD MMM YYYY')}</h6>
                                    </div>
                                  </div>
                                </a>
                              ))}
                            </div>
                            <button onClick={() => this.onCircularsClick()} class="btn btn-outline-dark w-100 mt-2">View All Messages</button>

                          </div>
                        </div>

                      </div>

                      {/* <!-- Download center --> */}
                      {sessionStorage.getItem("RoleIDSS") != 8 && <div class="col-md-4">
                        <div class="card shadow-none border-0 h-100-box">
                          <div class="card-body rounded-2">
                            <h6 class="card-title fw-semibold pt-2 pb-2">
                              <i class="bi bi-download text-primary me-2"></i> Download Center
                            </h6>
                            <div class="d-flex align-items-center justify-content-between rounded mb-1 p-1">
                              {/* <!-- Left: File icon + text --> */}
                              <div class="d-flex align-items-start">
                                <i class="bi bi-file-earmark-text text-primary fs-6 me-2"></i>
                                <div>
                                  <h6 class="fw-semibold">Registration Document</h6>
                                  <h6 class="text-muted">PDF</h6>
                                </div>
                              </div>
                              {/* <!-- Right: Download icon --> */}
                              <i
                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 1 } })}
                                // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Registration Form', buttonName: 'Download', action: 2 } })}
                                class="bi bi-download text-primary fs-5 semibold"></i>
                            </div>
                            {/* <div class="d-flex align-items-center justify-content-between rounded mb-1 p-1">
                              <div class="d-flex align-items-start">
                                <i class="bi bi-grid text-primary fs-6 me-2"></i>
                                <div>
                                  <h6 class="fw-semibold">Exhibitor Signature</h6>
                                  <h6 class="text-muted">PDF</h6>
                                </div>
                              </div>
                              <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Signature', buttonName: 'Download', action: 2 } })} class="bi bi-download text-primary fs-5 semibold"></i>
                            </div> */}
                            <div class="d-flex align-items-center justify-content-between rounded mb-1 p-1">
                              {/* <!-- Left: File icon + text --> */}
                              <div class="d-flex align-items-start">
                                <i class="bi bi-file-earmark-text text-primary fs-6 me-2"></i>
                                <div>
                                  <h6 class="fw-semibold">1st Proforma Invoice</h6>
                                  <h6 class="text-muted">PDF</h6>
                                </div>
                              </div>
                              <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download 1st Proforma Invoice', buttonName: 'Download', action: 4 } })} class="bi bi-download text-primary fs-5 semibold"></i>
                              {/* <div class="info-icon-wrapper">
                                <i class="bi bi-info-circle info-icon"></i>
                                <span class="tooltip-text">
                                  The Proforma  Invoice  download  facility  is temporarily  is unavailable. As our team is currently  reviewing the updates  submitted  you in the application.
                                </span> </div> */}
                            </div>
                            <div class="d-flex align-items-center justify-content-between rounded mb-1 p-1">
                              {/* <!-- Left: File icon + text --> */}
                              <div class="d-flex align-items-start">
                                <i class="bi bi-file-earmark-text text-primary fs-6 me-2"></i>
                                <div>
                                  <h6 class="fw-semibold">2nd Proforma Invoice</h6>
                                  <h6 class="text-muted">PDF</h6>
                                </div>
                              </div>
                              {/* {this.state.is2ndPicreated ? <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download 2nd Proforma Invoice', buttonName: 'Download', action: 5 } })} class="bi bi-download text-primary fs-5 semibold"></i>
                                : <div class="info-icon-wrapper">
                                  <i class="bi bi-info-circle info-icon"></i>
                                  <span class="tooltip-text">
                                    The download will be enabled only after 2nd PI has been created.
                                  </span> </div>
                              } */}
                              {this.state.is2ndPicreated ? <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download 2nd Proforma Invoice', buttonName: 'Download', action: 5 } })} class="bi bi-download text-primary fs-5 semibold"></i>
                                : <div class="info-icon-wrapper">
                                  <i class="bi bi-info-circle info-icon"></i>
                                  <span class="tooltip-text">
                                    The download will be enabled only after 2nd PI has been created.
                                  </span> </div>}
                            </div>
                            <div class="d-flex align-items-center justify-content-between rounded mb-1 p-1">
                              {/* <!-- Left: File icon + text --> */}
                              <div class="d-flex align-items-start">
                                <i class="bi bi-file-earmark-text text-primary fs-6 me-2"></i>
                                <div>
                                  <h6 class="fw-semibold">Ledger</h6>
                                  <h6 class="text-muted">PDF</h6>
                                </div>
                              </div>
                              {/* <!-- Right: Download icon --> */}
                              <i onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Ledger?', buttonName: 'Download', action: 8 } })} class="bi bi-download text-primary fs-5 semibold"></i>
                            </div>


                            <button onClick={() => this.setState({ downloadAll: true })} class="btn btn-aqua w-100 mt-0">Download All Documents</button>
                          </div>
                        </div>
                      </div>}

                      {/* <!-- Exit Form --> */}
                      {sessionStorage.getItem("RoleIDSS") != 8 && <div class="col-md-4">
                        <div class="card dashed shadow-sm h-100-box rounded-2">
                          <div class="card-body rounded-2">
                            <h6 class="card-title fw-semibold pt-2 pb-2">
                              <i class="bi bi-file-check  text-primary me-2"></i>Exit Form
                            </h6>
                            {!this.state.showExitPass && <div class="alert text-left card-bg-col py-1 mb-3 border-1 rounded-3 ">
                              <div class="d-flex align-items-center mb-1">
                                <i class="bi bi-exclamation-circle me-2 text-primary"></i>
                                <small class="text-dark fw-semibold">Available Soon</small>
                              </div>
                              <small class="text-muted text-warning">The Material Exit pass will be enabled only after the Material Entry pass has been filled out</small>
                            </div>}
                            <div class="d-flex justify-content-between mb-1">
                              <small>Form Status:</small>
                              <span class="NA badge rounded-pill">
                                {this.state.formStatus}
                              </span>
                            </div>
                            {/* <div class="d-flex justify-content-between mb-1">
                              <small>Available Form: </small>
                              <span class="date badge" style={{ color: '#272d51' }}>09 Dec 2026</span>
                            </div> */}
                            <div class="d-flex justify-content-between mb-1">
                              <small>Deadline: </small>
                              <span class="text-danger"><strong>{moment(ExitPassDueDate).format("D MMM YYYY")}</strong></span>
                            </div>
                            {/* <div class=" w-100 rounded mb-1 mt-3">
                              <small>
                                <b>Note:</b> Exit form will be completed before dismating your booth. It includes feedback survey.
                                Material disposal confirmation and final checklist
                              </small>
                            </div> */}
                            <button onClick={() => this.props.navigate("/exitPass", {})} class="btn btn-aqua w-100 mt-3"><i class="bi bi-file-earmark me-2"></i> Material Exit pass</button>
                          </div>
                        </div>
                      </div>}

                      {sessionStorage.getItem("RoleIDSS") != 8 && <div class="col-md-4">
                        <div class="card shadow-none h-100-box">
                          <div class="card-body rounded-2">
                            <div class="d-flex justify-content-between align-items-center">
                              <h6 class="card-title fw-semibold pt-1 pb-1">
                                <i class="bi bi-shop-window text-primary me-2"></i> Stall Possession Info
                              </h6>
                              {/* <div>
                                <a onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to View Application Details', buttonName: 'View', action: 0 } })
                                  //  this.onDocView(sessionStorage.getItem("ExhRegistrationIDSS"))
                                } class="text-primary fw-semibold me-3" title="View Application">
                                  <i class="bi bi-eye fs-6"></i>
                                </a>
                                <a onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Application Details', buttonName: 'Download', action: 1 } })
                                  //  this.onDocView(sessionStorage.getItem("ExhRegistrationIDSS"))
                                } class="text-primary fw-semibold" title="Download Application">
                                  <i class="bi bi-download fs-6"></i>
                                </a>
                              </div> */}
                            </div>

                            <div class="row mt-2">
                              <div class="col-6">
                                <div class="p-2 rounded card-bg-col h-100">
                                  {/* <div class="circle-logo single-color text-white mb-1">{sessionStorage.getItem("firstNameSS")[0]}</div> */}
                                  <h6 class="text-muted ">NDC Issued date</h6>
                                  <h6 class="semibold mt-1 ">{ndcissueDate != '' && ndcissueDate != null ? ndcissueDate : '-'}</h6>
                                </div>
                              </div>

                              <div class="col-6">
                                <div class="p-2 rounded card-bg-col h-100">
                                  {/* <div class="circle-logo single-color text-white mb-1">{sessionStorage.getItem("firstNameSS")[0]}</div> */}
                                  <h6 class="text-muted ">Stall Possession Taken Date</h6>
                                  <h6 class="semibold mt-1 ">{stallpossdate != '' && stallpossdate != null ? stallpossdate : '-'}</h6>
                                </div>
                              </div>
                            </div>


                            <div class="row mt-3">
                              <div class="col-6">
                                <div class="p-2 rounded card-bg-col h-100">
                                  {/* <div class="circle-logo single-color text-white mb-1">{sessionStorage.getItem("firstNameSS")[0]}</div> */}
                                  <h6 class="text-muted ">Exit Date - Exhibitor</h6>
                                  <h6 class="semibold mt-1 ">{exitdateExh != '' && exitdateExh != null ? exitdateExh : '-'}</h6>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="p-2 rounded card-bg-col h-100">
                                  {/* <div class="circle-logo single-color text-white mb-1">{sessionStorage.getItem("firstNameSS")[0]}</div> */}
                                  <h6 class="text-muted ">Exit Date - Contractor </h6>
                                  <h6 class="semibold mt-1 ">{exitdatecontractor != '' && exitdatecontractor != null ? exitdatecontractor : '-'}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>}

                      {/* <!-- Stall Damage Reporting --> */}
                      {sessionStorage.getItem("RoleIDSS") != 8 && <div class="col-md-4">
                        <div class="card shadow-none h-100-box">
                          <div class="card-body rounded-2">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h6 class="card-title fw-semibold pt-1 pb-1 mb-0 d-flex align-items-center">
                                <div><i class="bi bi-exclamation-circle text-primary me-2"></i> Stall Damage Reporting</div>
                              </h6>
                              <button onClick={() => this.setState({ showDamageReportModal: true })} className="btn btn-aqua py-1 px-2" style={{ fontSize: '13px' }}>View All</button>
                            </div>

                            {firstDamageGroup ? (
                              <>
                                <div class="mb-1">
                                  <label className=" mb-1" style={{ fontSize: '13px', color: '#212529' }}>Remark<span className="text-danger">*</span></label>
                                  <textarea
                                    className="form-control text-muted shadow-none"
                                    rows="2"
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fc', resize: 'none' }}
                                    value={firstDamageGroup.Remark || ''}
                                  />
                                </div>
                                <div class="mb-2">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                      <span class="fw-semibold text-dark me-2">Exit pass No:</span>
                                      <span class="text-dark fw-semibold" style={{ fontSize: '13px' }}>{firstDamageGroup.ExitNo}</span>
                                    </div>
                                  </div>
                                  <div class="border rounded-2 p-2 mb-1 mt-2">
                                    {firstDamageGroup.docs.map((docPath, idx) => (
                                      docPath != '' && docPath != null ? <div key={idx} class={`d-flex justify-content-between align-items-center${idx < firstDamageGroup.docs.length - 1 ? ' mb-2' : ''}`}>
                                        <div class="d-flex align-items-center">
                                          <i class="bi bi-file-earmark-text fs-5 text-muted me-2"></i>
                                          <small class="text-secondary fw-semibold">{docPath.split('/').pop()}</small>
                                        </div>
                                        <a href={`${BASE_URL.split('/api')[0]}${docPath}`} target="_blank" rel="noopener noreferrer" className="py-1 px-2 pb-0 d-flex align-items-center text-primary fw-semibold" style={{ fontSize: '12px', cursor: 'pointer', textDecoration: 'none' }}>
                                          View Picture
                                        </a>
                                      </div> : <></>
                                    ))}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div class="text-muted" style={{ fontSize: '13px' }}>No damage reports found.</div>
                            )}
                          </div>
                        </div>
                      </div>}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >

        {/* Damage Reporting Modal */}
        <Modal
          show={this.state.showDamageReportModal}
          onHide={() => this.setState({ showDamageReportModal: false })}
          size="xl"
          centered
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '16px' }} className="fw-semibold text-white d-flex align-items-center">
              <div><i className="bi bi-exclamation-circle text-white me-2"></i> Stall Damage Reporting</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {damageGroups.length === 0 && <div className="text-muted p-3">No damage reports found.</div>}
            {damageGroups.map((group) => (
              <div key={group.ExhExitPassHdrID} className="p-3 mb-3 rounded" style={{ backgroundColor: '#f8f9fc' }}>
                <div className="fw-semibold text-dark" style={{ fontSize: '14px' }}>Exit Pass No: {group.ExitNo}</div>

                <div className="mb-3 mt-2">
                  <label className="mb-1" style={{ fontSize: '13px', color: '#212529' }}>Remark<span className="text-danger">*</span></label>
                  <textarea
                    className="form-control text-muted shadow-none"
                    rows="2"
                    readOnly
                    style={{ fontSize: '13px', backgroundColor: '#fff', resize: 'none' }}
                    value={group.Remark || ''}
                  />
                </div>

                {group.docs.map((docPath, idx) => (
                  docPath != '' && docPath != null ? <div key={idx} className={`border rounded-2 p-2 bg-white d-flex justify-content-between align-items-center${idx < group.docs.length - 1 ? ' mb-2' : ''}`}>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-file-earmark-text fs-5 text-muted me-2"></i>
                      <small className="text-secondary fw-semibold">{docPath.split('/').pop()}</small>
                    </div>
                    <a href={`${BASE_URL.split('/api')[0]}${docPath}`} target="_blank" rel="noopener noreferrer" className="py-1 px-2 pb-0 d-flex align-items-center text-primary fw-semibold" style={{ fontSize: '12px', cursor: 'pointer', textDecoration: 'none' }}>
                      View Picture
                    </a>
                  </div> : <></>
                ))}
              </div>
            ))}
          </Modal.Body>
          <Modal.Footer className="justify-content-end">
            <button className="btn btn-gray" onClick={() => this.setState({ showDamageReportModal: false })}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.ManualFormAlert}
          onHide={() => this.setState({ ManualFormAlert: false })}
          size="xl"
          centered
          scrollable
          dialogClassName="action-modal"
        >
          <div className="action-modal-header">
            <span className="action-modal-icon"><i className="fa fa-file-text"></i></span>
            <div className="flex-grow-1">
              <h4 className="mb-0">Action Required</h4>
              <p className="mb-0">Please complete the below details to proceed further.</p>
            </div>
            <button type="button" className="action-modal-close" aria-label="Close" onClick={() => this.setState({ ManualFormAlert: false })}>&times;</button>
          </div>
          <Modal.Body className="action-modal-body">
            {/* Same checks as before: requirement details first (space booking form),
                then the matching manual form; completed items are not listed */}
            {[
              { key: 'power', name: 'Power', icon: 'fa-bolt', detailsFilled: this.state.isPowerDetailsFilled, formFilled: this.state.isPowerFormFilled, formId: 10 },
              { key: 'water', name: 'Water', icon: 'fa-tint', detailsFilled: this.state.isWaterDetailsFilled, formFilled: this.state.isWaterFormFilled, formId: 12 },
              { key: 'air', name: 'Air', icon: 'fa-cloud', detailsFilled: this.state.isAirDetailsFilled, formFilled: this.state.isAirFormFilled, formId: 13 },
              { key: 'edirectory', name: 'Edirectory', icon: 'fa-file-o', detailsFilled: this.state.isEdirectoryDetailsFilled, formFilled: this.state.isEdirectoryFormFilled, formId: 5 },
            ].map(item => {
              if (item.detailsFilled && item.formFilled) return null
              const needsDetails = !item.detailsFilled
              return (
                <div className="action-item" key={item.key}>
                  <span className={`action-item-icon action-${item.key}`}><i className={`fa ${item.icon}`}></i></span>
                  <p className="action-item-text mb-0">
                    {needsDetails
                      ? <>Kindly fill the <strong>{item.name}</strong> requirement details.</>
                      : <>Kindly submit the <strong>{item.name}</strong> manual form.</>}
                  </p>
                  <button
                    type="button"
                    className="btn btn-aqua action-item-link"
                    title={needsDetails ? 'Open the space booking form' : `Open the ${item.name} manual form`}
                    onClick={() => needsDetails ? this.props.navigate("/spacebooking", { state: {} }) : this.handleOpenForm(item.formId)}
                  >
                    Click Here <i className="fa fa-external-link ms-2"></i>
                  </button>
                </div>
              )
            })}
          </Modal.Body>
          <Modal.Footer className="action-modal-footer">
            <button className="btn btn-aqua action-modal-ok" type="button" onClick={() => this.setState({ ManualFormAlert: false })}>
              OK
            </button>
          </Modal.Footer>
        </Modal>
        <style>
          {`
           .corporate-link {
      color: #0d6efd;
      text-decoration: none;
    }

    .corporate-link:hover {
      color: #084298;
    }

    .top-menu {
      background: #fff;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid #ebebeb;
    }

    .top-menu ul {
      margin: 0;
      padding: 0;
      display: flex;
      list-style: none;
      align-items: center;
    }

    .top-menu li {
      padding: 8px 22px;
      font-size: 15px;
      cursor: pointer;
      color: #333;
    }

    .top-menu li.active {
      background: #51ccc1;
      color: #fff;
    }

    .top-menu li:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    .dropdown-light-shadow {
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.10) !important;
    }
      /* General Backgrounds */
.bg-purple { background-color: #22b2a5; }
.bg-light-purple { background-color: #f6f0ff; }
.bg-warning-subtle { background-color: #fff8e1; }
.bg-success-subtle { background-color: #e8f5e9; }
.bg-info-subtle { background-color: #e3f2fd; }
.bg-danger-subtle { background-color: #fdecea; }

/* Cards */
.card { border-radius: 10px; transition: all 0.3s ease; }
.card:hover { transform: translateY(-4px); box-shadow: 0 4px 15px rgba(95, 95, 95, 0.08); }
.card-body { padding: 5px 15px 10px 15px; }

/* Buttons */
.btn-custom { background-color: #22b2a5; color: #fff; }
.btn-custom:hover { background-color: #22b2a5; }

/* Padding & Height */
.p-3 { padding: 10px; }
.h-100 { height: 100%; }

/* Circular logos */
.circle-logo {
  width: 35px;
  height: 35px;
  background-color: #52b1ed;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Custom button styles */
.btn-purple {
  background-color: #22b2a5;
  color: #fff;
}
.btn-purple:hover {
  background-color: #22b2a5;
}

/* Inline circle-logo overrides */
.circle-logo-h6 { width: 35px; height: 35px; display: flex; align-items: center; justify-content: center; }

/* Badges with specific colors */
.badge-orange { background-color: orange; height: fit-content; }
.badge-green { background-color: #198754; height: fit-content; }
.badge-yellow { background-color: #FFA500; height: fit-content; }
.badge-blue { background-color: #0d6efd; height: fit-content; }
.badge-purple { background-color: #22b2a5; height: fit-content; }

/* Dashed card for Exit Form */
.card-dashed { border: 1px dashed #9ea7b1; }

/* Text size overrides */
.text-h6 { font-size: 11px; }
.text-xh6 { font-size: 10px; }

/* Custom Button (Purple) */
.btn-purple {
    background-color: #51ccc1;
    color: #fff;
}
.btn-purple:hover {
    background-color: #22b2a5; /* Slightly darker on hover */
}

/* Badges with custom colors */
.badge-orange {
    background-color: orange;
    height: fit-content;
}

/* Dashed Card Border */
.dashed {
    border: 1px dashed #9ea7b1;
}
.rounded-circle{
    width: 35px; 
    height: 35px;
}
.button {
    background-color: #22b2a5; color: #fff;
}
.zip{
    color: purple;
}
.new {
    background-color: orange; 
    height: fit-content;
}
.visitor{
    width: 35px; 
    height: 35px;
}
.general{
    /* background-color: #198754;  */
    background-color: #52b1ed;
    height: fit-content;
}
.booth{
    /* background-color: #FFA500;  */
    background-color: #84c2ec;;
    height: fit-content;
}
.meeting {
    /* background-color: #0d6efd;  */
    background-color: #84c2ec;;
    height: fit-content;
}
.networking {
/* background-color: #22b2a5; */
background-color: #84c2ec;;
 height: fit-content;
}
.btn-event {
    /* background-color: #198754; */
    background-color: #84c2ec;;
    color: #fff;
}
.NA {
    color: #141414; 
    height: fit-content
}
.dtae{
    height: fit-conten
}
.card-title {
    padding: 10px 0;
    font-size: 17px;
    
}
.card-body{
            /* border: 1px solid #ebebeb;
    background: #fbfbfb; */
        border: 1px solid #ebebeb;
    background: #f5f5f5;
}
.h-100-box{
    height: 93%;
}
.card-bg-col{
        /* background-color: #e2f1ff;
    border: 1px solid #d0e9ff; */
    /* background-color: #e4f2ff;
    border: 1px solid #dceeff; */
    /* background-color: #f3f3f3;
    border: 1px solid #e6e6e6; */
    background-color: #e9e9e9;
    border: 1px solid #e0e0e0;
}
.single-color-text{
  color: #52b1ed;
}
.single-color{
  background-color: #52b1ed;
}
.single-color-border{
  border: 1px solid #52b1ed;
}
.text-primary{
    color: #012970 !important;
}
.hotel-booking{
        border-color: #51ccc1;
    border-radius: 50px;
    color: #ffffff;
    background: #51ccc1;
    font-size: 14px !important;
}
.bg-primary-custom{
    background-color: #012970;
}
          `}
        </style>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    getExhibitorDashboard_action, insertHotelEnquiryDownload_action, taxInvoiceList_action, getLedgerList_action,
    getDrawerDetails_action, descriptionPreview_action, getManualForms_action, getExhibitorExitPassDetails_action,
    insertExhibitorBarcode_action, getManageAreaList_action, getExhibitorCircularList_action, fill_action
  })(Exhibitor_dashboard)
);
